import React, { Component } from 'react';
import "./moresetting.css"
import   SideNav from "./../../component/sidenav/sidenav.js"
import ReactCrop, { makeAspectCrop } from 'react-image-crop'
import  AuthService  from "../api/authentication.js";
import 'react-image-crop/dist/ReactCrop.css'
import  Moble from "./../../component/sidenav/moble.js"
import {base64StringtoFile,
downloadBase64File,
extractImageFileExtensionFromBase64,
image64toCanvasRef} from './ResuableUtils'
import axios from 'axios';
const imageMaxSize = 1000000000 // bytes
const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif'
const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => {return item.trim()})

const Auth = new AuthService();
// https://uvune-events.herokuapp.com
class MoreSetting extends Component {
    constructor(props) {
        super(props)
        this.imagePreviewCanvasRef = React.createRef()
      this.state ={
         inputOpenFileRef : React.createRef(), 
         image : "",
         loading: false,
         file: '',
        //  imagePreviewUrl: '' ,
        //  imageuploing : "",
         clearimage : false,
         about : " ",
            fullname: '',
            location: "",
            account_no : "",
            phone : "",
            phone_two :"",
            registar : "",
            disableLink:false,
            everFocusedfullname: false,
            everFocusedlocation: false,
            imageurl : "",
            inFocus: '',
            noerorrpage :  true,
            imageerror : false,
            imagemessage :  "",
            business_email: "",
            business_name : "",
            domain: 'https://uvune-events.herokuapp.com', 
            file: '',
            imagePreviewUrl: '', 
            isActive : false
      

        //  imagePreviewUrl: reader.result
      }
      this.chechconditionIinput()
        
    }

    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        this.setState({
          isActive : true
        })

        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            // body: JSON.stringify(dataedit),
          };

        //   console.log("data", requestOptions)
          fetch(this.state.domain+"/users/"+ Auth.getProfile().userId, requestOptions )
          .then(res => res.json())
          .then((result)=>{
            if(result){
                fetch(this.state.domain+"/organizers/"+ result.organizers_id, requestOptions)
                .then(res => res.json())
                .then((result)=>{
                    if(result){
                        //  console.log("result  ----------->>result.organizers_id",  result)
                        this.setState({
                        fullname:  result.display_name,
                        location:  result.address,
                        account_no : result.account_number,
                        phone :  result.business_mobile,
                        about : result.about,
                        clearimage : true,
                        image_url  : result.image_url,
                        business_email : result.business_email,
                        business_name :result.business_name,
                        account_bank : result.account_bank
                        //  disableLink :false
                    })
                    if(!this.state.fullname == "" && !this.state.location == ""  &&  !this.state.about == ""
                    && !this.state.account_no == "" 
                     && !this.state.phone =="" ){
                        this.setState({
                           submitIftrue : true,
                           firstTime : true
                        })
                       return true
                   }else{
                       this.setState({
                           submitIftrue : false,
                           firstTime : false
                        })
                       return  false
                   }
                    }
                  
                }).catch( (error) => {
                    //  console.log("errro", error);
                    //  console.log("error load", error )
                 });

    
            }
          }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
        });
      
       
        // console.log("about settiing ", this.state.about)
    }
    
   
    onChangeFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        const reader = new FileReader();
        var file = event.target.files[0];
        // console.log("render", reader)
        reader.onloadend = () => {
            this.setState({
              file: file,
              imagePreviewUrl: reader.result,
            });
          }
       
        // console.log("thus",this.state.imagePreviewUrl);
        ///console.log("thus",)
        // console.log(file);
        this.setState({file}); /// if you want to upload latter
        if(file){
            reader.readAsDataURL(file)
        }
       
    }

 
      

    verifyFile = (files) => {
        // console.log("file", files)
        if (files && files.length > 0){
            const currentFile = files[0]
            const currentFileType = currentFile.type
            const currentFileSize = currentFile.size
            if(currentFileSize > imageMaxSize) {
                alert("This file is not allowed. " + currentFileSize + " bytes is too large")
                return false
            }
            if (!acceptedFileTypesArray.includes(currentFileType)){
                alert("This file is not allowed. Only images are allowed.")
                return false
            }
            return true
        }
    }

    

    upDate_data = (event) =>{
        event.preventDefault()
        // console.log("update",this.business_name.value, this.phone.value, this.location.value, this.about.value , this.account_no.value)
       if(this.state. submitIftrue){
        this.setState({
            loading:true
        })
        {/* display_name: this.fullname.value,
             business_mobile: this.phone.value,
             business_name: this.businessName.value,
             business_email : this.businessEmail.value,
             account_bank  :this.accountbank.value,
             address : this.location.value,
             about : this.about.value,
             account_number: this.account.value, */}
         const update_data = {
            business_mobile: this.phone.value,
            business_name: this. business_name.value,
            business_email : this.business_email.value,
            // account_bank  :this.account_bank.value,
            address : this.location.value,
            about : this.about.value,
            // account_number: this.account_no.value,

         }

         const requestOptions = {
             method: 'PATCH', 
             headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
             body: JSON.stringify(update_data),
         };
        //  console.log("data update", requestOptions, this.props.user. _id)
         fetch(this.state.domain+"/organizers/"+ this.props.organizer._id, requestOptions)
         .then(res => res.json())
         .then((result)=>{
             if(result){
                //  console.log("result", result)
                if(this.state.imagePreviewUrl === ""){
                    this.setState({
                        loading:false
                    })
                    this.props.history.replace({
                        pathname: '/dashboard/',
                        // state: { detail: res}
                        state: { notice: "true" , message:"Organizers updated" }
                      })
                }else{
                    this.data(result)
                    this.setState({
                        loading:false
                    })
                }
                
                
             }
           
         }).catch( (error) => {
             //  console.log("errro", error);
            //   console.log("error load", error )
          });
       }else{
        //   console.log("false")
       }    
       

    }

    handleClearToDefault = event =>{
        if (event) event.preventDefault()
        // console.log("   clearimage",   )
        
        this.setState({
            clearimage : false
        })
        
        // console.log("   clearimage",  this.state. clearimage)
    }

    
  _handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });
    }

    reader.readAsDataURL(file)
  }

  showTicket=(event)=>{
    event.preventDefault()
    this.setState({
      ticket : true
    })

  }

  
  data=(data)=>{
  //   console.log("result form data organizer. ", this.props.organizer._id)
  //   console.log("jdtbgkhjsdtg------>image",this.state.image)
  //   console.log("data id  ----===>", data._id)
  const formData = new FormData();
    formData.append('uri', this.state.file)
    // console.log("file upload.....",this.state.file)
    // formData.append('featured_image', true);
    formData.append('organizers_id', this.props.organizer._id);

   
    const options = {
        method: 'POST',
        headers: { 
            'content-type': 'multipart/form-data',
        'access-control-allow-origin': '*',
        'Authorization': Auth.getToken(), 
        },
        url:this.state.domain+"/upload-logo",
    };
        // console.log("data ----====>",options )
        axios.post(options.url, formData, options.headers)
          .then(res => {
            if(res){
              // console.log("data----->image", res)
              if(res.status === 201)
              // console.log("data----->image3", res)
          
              this.props.history.replace({
                pathname: '/dashboard/',
                // state: { detail: res}
                state: { notice: "true" , message:"Create Event" }
              })
                this.setState({
                    termsError : true,
                    termsMS : "Upload successful",
                    loadingTerms:false,
                    Ifterms :false
                })
                // console.log("data----->update", res)
         }
           
           this.timeout()
          }).catch( (error) => {
            //    console.log("error==------>",error)
               this.setState({
                 termsError : true,
                 termsMS : "Image to large",
                 loadingTerms:false,
                 Ifterms :false
               })
               this.timeout()
         });

  }




 
    
        changeAbout=(e)=> {
            this.setState({ about: e.target.value });
            // console.log(this.chechconditionIinput())
        }

        locationChange=(e)=>{
            this.setState({ location: e.target.value });
            // console.log("judge",)
        //   console.log(   this.Is_Empty_or_Undefined ( e.target.value))
            // console.log(this.chechconditionIinput())
        }

        business_email  = (e) => {
            e.preventDefault()
            this.setState({  business_email: e.target.value });
            // console.log("fullname", e.target.value )
            // console.log(this.chechconditionIinput())

         }

         account_noChange=(e)=>{
            this.setState({ account_no: e.target.value });
            // console.log(this.chechconditionIinput())
        }

        registar_onChange=(e)=>{
            this.setState({ registar: e.target.value });
            // console.log(this.chechconditionIinput()) 
        }

        phone_one_onChange = (e)=>{
            this.setState({ phone_one: e.target.value });
            // console.log(this.chechconditionIinput())   
        }
        phone_two_onChange=(e)=>{
            this.setState({ phone_two: e.target.value });
            // console.log(this.chechconditionIinput())  
        }
        
         chechconditionIinput=()=>{
            //  console.log("judge chechconditionIinput")
              if(!this.state.fullname == "" && !this.state.location == ""  &&  !this.state.about == ""
             && !this.state.account_no == ""  ){
                 this.setState({
                    submitIftrue : true
                 })
                return true
            }else{
                this.setState({
                    submitIftrue : false
                 })
                return  false
            }
         }

         timeout() {
            setTimeout(function() {
                this.setState({
                    imageerror : false
                })
            //   console.log(this.state.noticeshow);
            }.bind(this), 3000);
        }

        
        logout = () =>{
            // console.log("judge love")
            this.props.logout()
          }
        
        
  render() {
    let {imagePreviewUrl} = this.state;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (<img src={imagePreviewUrl} />);
    } else {
      $imagePreview = (<div className="previewText">Please select an Image for Preview</div>);
    }
    // console.log("disable", this.props.disable)
    // console.log("users ====", this.props.user ,"organizer", this.props.organizer)
    return (
            
            <div className="moreSetting"> 
               <div className="Activity-moble-nav-body">
                    < Moble logout={this.logout}/>
               </div>    
               <SideNav vanImage={this.props.organizer.image_url}   organizers404={this.props.organizers404} email={this.props.user.email}
                logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name} isActiveM={this.state.isActive} /> 

                    <div className="main">
                   
                                        {/* <div className="errormeage">  <img src={this.state.imagePreviewUrl} /> </div> */}
                                 
                        <div className="more-setting-body"> 
                          {
                              this.state.imageerror ?
                              <div className="more-setting-image-error">
                                 <div className="notification">
                                        {/* <button class="delete"></button> */}
                                        <strong>  {this.state.imagemessage} </strong>
                                 </div>
                                
                                </div>
                              :
                              <div></div>
                          }
                    
                          <div className="more-setting-sub">  </div>
                          <div className="">

                          <div className="organizer-edit-page-body">
                             <div className="event-edit-page-title"><p>Organizer's Profile</p></div>
                                    <div className="columns">
                                        <div className="column is-three-fifths">
                                        <div className="event-edit-page-form">
                                        <div className="previewComponent">
                                          <div className="imgPreview">
                                                {
                                                    this.state.imagePreviewUrl  === "" ?
                                                     <img src={this.state.image_url} />
                                                 
                                                    :
                                                    $imagePreview
                                                }
                                                    
                                           </div>
                                         <form onSubmit={this.upDate_data}>
                                               <div className="field" style={{"position":"relative","left":"15px"}}>
                                                 <div className="file is-small">
                                                   <label className="file-label">
                                                     <input className="file-input"  type="file"  onChange={(e)=>this._handleImageChange(e)} name="resume" />
                                                     <span className="file-cta">
                                                       <span className="file-icon">
                                                         <i className="fas fa-upload"></i>
                                                       </span>
                                                        <span className="file-label">
                                                            Image file…
                                                        </span>
                                                     </span>
                                                   </label>
                                                 </div>
                                               </div>
                                               <div className="field  field-input-event-style">
                                                    <label className="label">Name</label>
                                                    <div className="control">
                                                    <input className="input" type="tel" 
                                                           ref={ input => this.business_name = input}
                                                     
                                                            defaultValue={this.state.business_name}
                                                             placeholder="Business name"  required/>
                                                    </div>
                                                </div>
                                                <div className="field  field-input-event-style">
                                                    <label className="label">Business email</label>
                                                    <div className="control">
                                                    <input className="input" type="tel" 
                                                          ref={ input => this. business_email = input }
                                                          type="text" defaultValue={this.state.business_email}
                                                         //  onChange={this.business_email}
                                                           placeholder=" Organizers Email" />
                                                    </div>
                                                </div>
                                                <div className="field  field-input-event-style">
                                                    <label className="label">Phone</label>
                                                    <div className="control">
                                                    <input className="input" type="tel" 
                                                           ref={ input => this.phone = input}
                                                           onChange={this.phone_one_onChange }
                                                            defaultValue={this.state.phone}
                                                             placeholder="Phone "  required/>
                                                    </div>
                                                </div>
                                                <div className="field  field-input-event-style">
                                                    <label className="label">Location</label>
                                                    <div className="control">
                                                    <input className="input" type="text"
                                                            onChange={this.locationChange }
                                                              ref={ input => this.location = input} 
                                                              defaultValue={this.state.location} placeholder="Location" />
                                                    </div>
                                                </div>
                                                <div className="field  field-input-event-style">
                                                <label className="label">   About Organizers </label>
                                                    <div className="control">
                                                           
                                                           <textarea className="textarea "  value={this.state.about} onChange={this.changeAbout} ref={ input => this.about = input}  defaultValue={this.state.about}   placeholder="About your school">
                                                               {/* {this.state.about} */}
                                                           </textarea>  
                                                       </div>          
                                                   </div>
                                                  
                                                   {
                                                        this.state.loading ? 
                                                        <div className="hero is-bold is-fullheight">
                                                                <div className="level-item">
                                                                <a className="button is-loading is-large is-light">Loading</a>
                                                                </div>
                                                                
                                                            </div>
                                                        :
                                                         <div >
                                                            {
                                                            this.state.submitIftrue ? 
                                                                <button className="button is-success is-rounded">Submit</button>
                                                                :
                                                                <span> 
                                                                
                                                                <a className="button is-success" title="Disabled button" disabled>Submit</a>
                                                                </span>
                                                            }
                                                           </div>     
                                                           
                                                  
                                                  }
                                               
                                                <br/>
                                              </form>
                                          </div>
                                          </div>
                                        </div>
                                        <div className="column">
                                        <div className="more-setting-left-body">
                                          <p>Links</p>
                                          <div className="more-setting-left">
                                                
                                          <div className="field  field-input-event-style">
                                                <label className="label">   <small>Website</small> </label>
                                                <div className="field-body">
                                                    <div className="field is-expanded">
                                                    <div className="field has-addons">
                                                        <p className="control">
                                                        <a className="button is-static">
                                                        <i className="fas fa-link"></i>
                                                        </a>
                                                        </p>
                                                        <p className="control is-expanded">
                                                        <input className="input" type="tel" placeholder="domain.com"/>
                                                        </p>
                                                    </div>
                                              </div>      
                                                    <br/>
                                                 
                                                    </div>
                                                </div>
                                            <div className="field  field-input-event-style">
                                                <label className="label">   <small>Facebook Link</small> </label>
                                                <div className="field-body">
                                                    <div className="field is-expanded">
                                                    <div className="field has-addons">
                                                        <p className="control">
                                                        <a className="button is-static">
                                                        <i className="fab fa-facebook-square"></i>
                                                        </a>
                                                        </p>
                                                        <p className="control is-expanded">
                                                        <input className="input" type="tel" placeholder="facebook.com/pagename"/>
                                                        </p>
                                                    </div>
                    
                                                    </div>
                                                </div>
                                                </div>
                                                
                                                <div className="field  field-input-event-style">
                                                    <label className="label">   <small>Twitter Link</small> </label>
                                                    <div className="field-body">
                                                        <div className="field is-expanded">
                                                        <div className="field has-addons">
                                                            <p className="control">
                                                            <a className="button is-static">
                                                            <i className="fab fa-twitter-square"></i>
                                                            </a>
                                                            </p>
                                                            <p className="control is-expanded">
                                                            <input className="input" type="tel" placeholder="Twitter Link"/>
                                                            </p>
                                                        </div>
                                                        </div>
                                                    </div>
                                                  </div> 
                                                  <div className="field  field-input-event-style">
                                                    <label className="label">   <small>Instagram Link</small> </label>
                                                    <div className="field-body">
                                                        <div className="field is-expanded">
                                                        <div className="field has-addons">
                                                            <p className="control">
                                                            <a className="button is-static">
                                                            <i className="fab fa-instagram"></i>
                                                            </a>
                                                            </p>
                                                            <p className="control is-expanded">
                                                            <input className="input" type="tel" placeholder="Twitter Link"/>
                                                            </p>
                                                        </div>
                        
                                                        </div>
                                                    </div>
                                                  </div>  
                                                <br/>
                                                
                                            </div>
                                        </div>
                                          

                                        </div>
                                        
                                      </div>
                                 
                                  
                                    </div>
                                
                         </div>
                    </div>
              
                </div>
           </div>     

    )

}





}

export default MoreSetting;


// WEBPACK FOOTER //
// ./src/component/setting/moresetting.js